'use client';

import { useMemo } from 'react';

interface StarsBackgroundProps {
  glowColor?: string;
}

export default function StarsBackground({ glowColor = 'bg-blue-500/5' }: StarsBackgroundProps) {
  const stars = useMemo(() =>
    Array.from({ length: 120 }, () => ({
      width: Math.random() * 2 + 0.5,
      height: Math.random() * 2 + 0.5,
      top: Math.random() * 100,
      left: Math.random() * 100,
      opacity: Math.random() * 0.6 + 0.2,
    })),
  []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {stars.map((star, i) => (
        <div
          key={i}
          className="absolute rounded-full bg-white"
          style={{
            width: `${star.width}px`,
            height: `${star.height}px`,
            top: `${star.top}%`,
            left: `${star.left}%`,
            opacity: star.opacity,
          }}
        />
      ))}
      <div className={`absolute top-0 left-1/4 w-[500px] h-[300px] ${glowColor} rounded-full blur-3xl`} />
      <div className="absolute top-20 right-0 w-[400px] h-[200px] bg-amber-500/5 rounded-full blur-3xl" />
    </div>
  );
}
